import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Select, Input, Typography, Tag, Rate, Spin } from 'antd';
import {
    SearchOutlined,
    EnvironmentOutlined,
    StarFilled,
    ArrowRightOutlined,
    CustomerServiceOutlined,
    CameraOutlined,
    CarOutlined,
    HomeOutlined,
    GiftOutlined,
    SkinOutlined,
    SafetyOutlined,
    HeartOutlined,
} from '@ant-design/icons';
import usePublicStore from '../../store/publicStore';
import DateLine from '../../components/DateLine/DateLine';

const { Title, Text } = Typography;
const P = '#5F33E1';

const CATEGORIES = [
    { icon: <HomeOutlined />, label: 'Restoranlar', key: 1 },
    { icon: <CustomerServiceOutlined />, label: 'Honandalar', key: 2 },
    { icon: <CameraOutlined />, label: 'Fotograf', key: 3 },
    { icon: <CarOutlined />, label: "To'y korteji", key: 4 },
    { icon: <GiftOutlined />, label: "Bezatish", key: 5 },
    { icon: <SkinOutlined />, label: "Ko'ylak", key: 6 },
    { icon: <HeartOutlined />, label: 'Gul', key: 7 },
    { icon: <SafetyOutlined />, label: 'Boshqa', key: 8 },
];

const STATS = [
    { num: '500+', label: 'Xizmat ko\'rsatuvchilar' },
    { num: '50+', label: 'Xizmat turlari' },
    { num: '14', label: 'Viloyat' },
    { num: '10K+', label: 'Mamnun mijozlar' },
];

/* ─── HERO ─── */
function Hero() {
    const navigate = useNavigate();
    const { regions, fetchRegions, serviceTypes, fetchServiceTypes, setFilter } = usePublicStore();

    useEffect(() => {
        fetchRegions();
        fetchServiceTypes();
    }, [fetchRegions, fetchServiceTypes]);

    const handleSearch = () => navigate('/services');

    return (
        <section className="qk-hero">
            <div className="qk-hero-left" style={{ flex: '0 0 55%', zIndex: 2 }}>
                <div className="qk-animate">
                    <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, display: 'block' }}>
                        Quvonchli Kun platformasi
                    </Text>
                    <Title style={{ color: '#fff', fontSize: 'clamp(24px, 3.5vw, 32px)', lineHeight: 1.15, marginBottom: 24, fontWeight: 800 }}>
                        To'y va tantanangiz<br />
                        uchun <span style={{ color: '#FFE44D' }}>eng yaxshi</span><br />
                        xizmatlar
                    </Title>
                    <Text style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, lineHeight: 1.7, display: 'block', marginBottom: 36, maxWidth: 480 }}>
                        Restoranlar, honandalar, fotograf, bezatish va boshqa barcha xizmatlarni bir joydan toping va band qiling.
                    </Text>
                </div>

                <div className="qk-search-bar qk-animate qk-animate-delay-2">
                    <div style={{ flex: 1, minWidth: 140 }}>
                        <Select
                            placeholder="Xizmat turi"
                            variant="borderless"
                            style={{ width: '100%' }}
                            size="small"
                            allowClear
                            options={serviceTypes.map(s => ({ label: s.name, value: s.id }))}
                            onChange={(v) => setFilter('service_type_id', v)}
                        />
                    </div>
                    <div style={{ width: 1, height: 36, background: '#E5E7EB' }} />
                    <div style={{ flex: 1, minWidth: 140 }}>
                        <Select
                            placeholder="Viloyat"
                            variant="borderless"
                            style={{ width: '100%' }}
                            size="small"
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            options={regions.map(r => ({ label: r.nameUz, value: r.id }))}
                            onChange={(v) => setFilter('region_id', v)}
                        />
                    </div>
                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={handleSearch}
                        style={{
                            background: `linear-gradient(135deg, ${P} 0%, #8B5CF6 100%)`,
                            border: 'none', borderRadius: 12,
                            height: 44, paddingInline: 28,
                            fontWeight: 600, fontSize: 14,
                            boxShadow: '0 4px 14px rgba(95,51,225,0.4)',
                        }}
                    >
                        Qidirish
                    </Button>
                </div>
                <div className="qk-stats-bar" style={{
                    padding: '5px 5px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: 24, maxWidth: 1280, margin: '0 auto',
                    borderRadius: 20, position: 'relative', zIndex: 3,
                    boxShadow: '0 12px 40px rgba(95,51,225,0.25)',
                }}>
                    {STATS.map((s, i) => (
                        <div key={i} className="qk-stat">
                            <div className="qk-stat-num">{s.num}</div>
                            <div className="qk-stat-label">{s.label}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="qk-hero-right" style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', zIndex: 2 }}>
                <div style={{ position: 'relative' }}>
                    <img
                        src="https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80"
                        alt="To'y marosimi"
                        style={{ width: '100%', maxWidth: 440, borderRadius: 24, objectFit: 'cover', boxShadow: '0 24px 64px rgba(0,0,0,0.3)', height: 380 }}
                    />
                    <div style={{
                        position: 'absolute', top: 20, left: -30,
                        background: 'var(--qk-card-bg)', borderRadius: 16, padding: '14px 20px',
                        boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
                        display: 'flex', alignItems: 'center', gap: 12,
                    }}>
                        <div style={{ width: 44, height: 44, borderRadius: 12, background: '#EEE9FF', display: 'flex', alignItems: 'center', justifyContent: 'center', color: P, fontSize: 20 }}>
                            <HeartOutlined />
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, fontSize: 18, color: 'var(--qk-text)' }}>10,000+</div>
                            <div style={{ fontSize: 12, color: '#9CA3AF' }}>Mamnun juftliklar</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

/* ─── CATEGORIES ─── */
function CategoriesSection() {
    const navigate = useNavigate();
    
    const { serviceTypes, fetchServiceTypes } = usePublicStore();

    useEffect(() => {
        fetchServiceTypes();
    }, [fetchServiceTypes]);

    const handleClick = (key) => {
        navigate('/services');
    };

    return (
        <section className="qk-section" style={{ paddingTop: 20 }}>
           
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
                gap: 16,
            }}>
                {serviceTypes.map((cat) => (
                    <div key={cat.id} className="qk-category-card" onClick={() => handleClick(cat.id)}>
                        <div className="qk-cat-icon">
                            <img src={process.env.REACT_APP_URL + cat.icon} alt={cat.name} className="qk-cat-img" />
                        </div>
                        <div className="qk-cat-title">{cat.name}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}

/* ─── SERVICE CARD ─── */
function ServiceCard({ service }) {
    const img = service.images?.[0]?.file_path
        ? process.env.REACT_APP_URL + service.images[0].file_path
        : 'https://images.unsplash.com/photo-1519741497674-611481863552?w=400&q=60';

    return (
        <Link to={`/services/${service.id}`} className="qk-link-reset">
            <div className="qk-service-card">
                <div className="qk-card-img-wrap">
                    <img className="qk-card-img" src={img} alt={service.name} />
                </div>
                <div className="qk-card-body">
                    <div className="qk-card-head">
                        <div>
                            <div className="qk-card-title">{service.name}</div>
                            <div className="qk-card-location">
                                <EnvironmentOutlined className="qk-card-location-icon" />
                                {service.region?.nameUz || service.district?.nameUz || '—'}
                            </div>
                        </div>
                        {service.serviceType && (
                            <Tag className="qk-card-tag">
                                {service.serviceType.name}
                            </Tag>
                        )}
                    </div>
                    <div className="qk-card-foot">
                        <div className="qk-card-rating">
                            <Rate disabled value={service.average_rating || 0} allowHalf className="qk-card-rate" />
                            <Text type="secondary" className="qk-card-comments">
                                ({service.total_comments || 0})
                            </Text>
                        </div>
                        {service.min_price && (
                            <Text strong className="qk-card-price">
                                {Number(service.min_price).toLocaleString()} so'm
                            </Text>
                        )}
                    </div>
                </div>
                <DateLine serviceId={service.id} />
            </div>
        </Link>
    );
}

/* ─── FEATURED SERVICES ─── */
function FeaturedServices() {
    const { services, loading, fetchServices } = usePublicStore();

    useEffect(() => {
        fetchServices();
    }, [fetchServices]);

    return (
        <section className="qk-section qk-featured-section">
            <div className="qk-featured-header">
                <div>
                    <h2 className="qk-section-title">
                        Mashhur <span className="qk-primary-text">xizmatlar</span>
                    </h2>
                    <p className="qk-section-sub qk-section-sub-tight">
                        Eng ko'p tanlangan xizmatlar
                    </p>
                </div>
                <Link to="/services">
                    <Button
                        type="primary"
                        icon={<ArrowRightOutlined />}
                        className="qk-gradient-btn"
                    >
                        Barchasini ko'rish
                    </Button>
                </Link>
            </div>

            {loading ? (
                <div className="qk-loading-state">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="qk-services-grid">
                    {services.slice(0, 8).map((s) => (
                        <ServiceCard key={s.id} service={s} />
                    ))}
                </div>
            )}
        </section>
    );
}

/* ─── HOW IT WORKS ─── */
function HowItWorks() {
    const steps = [
        { num: '01', title: 'Xizmatni tanlang', desc: 'Kerakli xizmat turini tanlang va variantlarni ko\'rib chiqing' },
        { num: '02', title: 'Batafsil tanishing', desc: 'Rasmlar, izohlar va narxlar bilan tanishing' },
        { num: '03', title: 'Band qiling', desc: 'O\'zingizga qulay sanani tanlab, xizmatni band qiling' },
    ];

    return (
        <section className="qk-section">
            <div className="qk-section-center">
                <h2 className="qk-section-title">
                    Qanday <span className="qk-primary-text">ishlaydi?</span>
                </h2>
                <p className="qk-section-sub">Uch oddiy qadamda</p>
            </div>
            <div className="qk-steps-grid">
                {steps.map((s, i) => (
                    <div key={i} className="qk-step-card">
                        <div className={i === 1 ? 'qk-step-num qk-step-num-active' : 'qk-step-num'}>
                            {s.num}
                        </div>
                        <h3 className="qk-step-title">{s.title}</h3>
                        <p className="qk-step-desc">{s.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

/* ─── CTA ─── */
function CtaSection() {
    return (
        <div className="qk-cta-wrapper">
            <section className="qk-cta">
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h2 style={{ color: '#fff', fontSize: 'clamp(20px, 5vw, 36px)', fontWeight: 800, marginBottom: 16 }}>
                        O'z xizmatlaringizni joylashtiring
                    </h2>
                    <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, marginBottom: 32, maxWidth: 500, margin: '0 auto 32px' }}>
                        Minglab foydalanuvchilar sizning xizmatlaringizni kutmoqda.
                        Hoziroq ro'yxatdan o'ting va biznesni boshlang.
                    </p>
                    <Link to="/auth/register">
                        <Button
                            size="large"
                            style={{
                                background: '#fff', color: P,
                                border: 'none', borderRadius: 14,
                                height: 52, paddingInline: 40,
                                fontWeight: 700, fontSize: 16,
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                            }}
                        >
                            Hamkor bo'lish <ArrowRightOutlined />
                        </Button>
                    </Link>
                </div>
            </section>
        </div>
    );
}

/* ─── PAGE ─── */
const Home = () => (
    <>
        <Hero />
        <CategoriesSection />
        <FeaturedServices />
        <HowItWorks />
        <CtaSection />
    </>
);

export default Home;
